exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.5@core-js/modules/_wks-ext.js
// module id = 189
// module chunks = 0